import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=42e15242&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=42e15242&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e15242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e15242')) {
      api.createRecord('42e15242', component.options)
    } else {
      api.reload('42e15242', component.options)
    }
    module.hot.accept("./ConfirmDialog.vue?vue&type=template&id=42e15242&scoped=true", function () {
      api.rerender('42e15242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/ConfirmDialog.vue"
export default component.exports